<template>
    <span class="disclaimer">
        <slot />
    </span>
</template>

<script>
export default {
    name: 'Disclaimer'
}
</script>

<style lang="scss" scoped>
.disclaimer {
    height: $sub-header-height;
    min-height: 50px;
    padding: 5px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    color: $red;
    border: 0.1rem solid $red;
    background-color: $red-alpha;

    @media screen and #{$new-break2close} {
        overflow: auto;
        @include hide-scrollbar();
    }
    @media screen and #{$new-break3open} {
        align-items: center;
        justify-content: center;
    }
}
</style>
